<template>
	<div>
		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>

		<Transition name="route-loading-fade">
			<div v-if="routeLoadingState.active && activeLoadingComponent" class="route-loading-overlay">
				<component :is="activeLoadingComponent" />
			</div>
		</Transition>
	</div>
</template>

<script setup lang="ts">
import ProductDetailRouteLoading from '~/components/loading/ProductDetailRouteLoading.vue';

// 使用NuxtLayout组件来对对对启用布局系统
useHead({
	script: [
		{
			src: '/initScript/calcRootRem.js',
			tagPosition: 'head',
		},
		...(process.env.NODE_ENV === 'production'
			? [
					{
						children:
							"var _hmt = window._hmt || [];(function(){var hm=document.createElement('script');hm.src='https://hm.baidu.com/hm.js?147eac8529d6a0842b1a0cd2fbae0fea';var s=document.getElementsByTagName('script')[0];s.parentNode.insertBefore(hm,s);})();",
						tagPosition: 'bodyClose',
					},
			  ]
			: []),
	],
});

const routeLoadingState = useRouteLoadingSkeletonState();

const activeLoadingComponent = computed(() => {
	if (routeLoadingState.value.key === 'product-detail') {
		return ProductDetailRouteLoading;
	}

	return null;
});

onMounted(() => {
	useWeixin().initWx();
});
</script>

<style scoped>
.route-loading-overlay {
	position: fixed;
	inset: 0;
	z-index: 9999;
	background: #f3f4f6;
}

.route-loading-fade-enter-active,
.route-loading-fade-leave-active {
	transition: opacity 0.18s ease;
}

.route-loading-fade-enter-from,
.route-loading-fade-leave-to {
	opacity: 0;
}
</style>
